import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, photoUrl } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import MultiSelect from "@/components/MultiSelect";
import { LANGUAGES, INTERESTS } from "@/lib/options";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [f, setF] = useState({
    display_name: user?.display_name || "",
    bio: user?.bio || "",
    city: user?.city || "",
    interested_in: user?.interested_in || "any",
    languages: user?.languages || [],
    preferred_languages: user?.preferred_languages || [],
    interests: user?.interests || [],
    preferred_interests: user?.preferred_interests || [],
  });
  const u = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/profile", f);
      await refresh();
      toast.success("Profile updated");
    } catch (err) { toast.error(err?.response?.data?.detail || "Update failed"); }
  };

  if (!user) return null;
  return (
    <div className="min-h-screen bg-dc-gradient p-4">
      <div className="max-w-xl mx-auto">
        <div className="flex items-center justify-between">
          <h1 className="font-display text-2xl font-extrabold">Profile</h1>
          <Link to="/dashboard" className="text-sm text-purple-200">← Dashboard</Link>
        </div>

        <div className="glass-strong rounded-3xl p-6 mt-4">
          <div className="flex gap-2 flex-wrap">
            {(user.photo_ids || []).map((pid) => (
              <img key={pid} src={photoUrl(pid)} className="w-20 h-20 rounded-xl object-cover" alt="" />
            ))}
          </div>
          <form onSubmit={save} className="mt-4 space-y-3">
            <input data-testid="prof-name" className="dc-input" value={f.display_name} onChange={u("display_name")} placeholder="Display name" />
            <input data-testid="prof-city" className="dc-input" value={f.city} onChange={u("city")} placeholder="City" />
            <select data-testid="prof-interested" className="dc-input" value={f.interested_in} onChange={u("interested_in")}>
              <option value="female">Interested in: Female</option>
              <option value="male">Interested in: Male</option>
              <option value="any">Interested in: Any</option>
            </select>
            <textarea data-testid="prof-bio" rows={4} maxLength={400} className="dc-input" value={f.bio} onChange={u("bio")} placeholder="Bio" />

            <MultiSelect label="Languages you speak" options={LANGUAGES} value={f.languages} onChange={(v) => setF({ ...f, languages: v })} testPrefix="prof-lang" />
            <MultiSelect label="Preferred languages" options={LANGUAGES} value={f.preferred_languages} onChange={(v) => setF({ ...f, preferred_languages: v })} testPrefix="prof-prefLang" />
            <MultiSelect label="Hobbies & interests" options={INTERESTS} value={f.interests} onChange={(v) => setF({ ...f, interests: v })} testPrefix="prof-int" />
            <MultiSelect label="Preferred interests" options={INTERESTS} value={f.preferred_interests} onChange={(v) => setF({ ...f, preferred_interests: v })} testPrefix="prof-prefInt" />

            <button data-testid="prof-save" className="btn-cta rounded-2xl px-5 py-2.5">Save changes</button>
            <div className="text-xs text-purple-200/60">Note: changing name or bio sends your profile back for admin review.</div>
          </form>
          <style>{`.dc-input{width:100%;background:rgba(10,4,20,0.6);border:1px solid rgba(168,85,247,0.3);border-radius:12px;padding:10px 12px;font-size:14px;outline:none;color:#fff}`}</style>
        </div>
      </div>
    </div>
  );
}
